export default __webpack_public_path__ + "static/media/sugarcane-icon.0d90b3f0.svg";